import { createFileRoute, Outlet } from '@tanstack/react-router';
import StaffPortal from '../../components/portals/StaffPortal';

export const Route = createFileRoute('/staff/orders')({
  component: StaffOrdersRoute,
});

function StaffOrdersRoute() {
  return (
    <StaffPortal>
      <Outlet />
    </StaffPortal>
  );
}
